'use client';

import React from 'react';

import { DEFAULT_OFFSET_IN_PX } from './constants';
import { scrollToElement } from './scrollToElement';
import { useHash } from '@/utils/hashChange';

interface ScrollWithOffsetProps {
  offset?: number;
  targetHash: string;
  elementRef: React.RefObject<HTMLElement>;
}

// reexport scrollToElement
export { scrollToElement };

export function useScrollWithOffset({ offset = DEFAULT_OFFSET_IN_PX, targetHash, elementRef }: ScrollWithOffsetProps) {
  // Use centralized hash management
  const [hash] = useHash();

  // on page fully loaded
  React.useEffect(() => {
    const onLoaded = () => {
      if (hash === targetHash) {
        scrollToElement({ elementRef, offset });
      }
    };

    window.addEventListener('load', onLoaded);

    return () => {
      window.removeEventListener('load', onLoaded);
    };
  }, [hash, targetHash, elementRef, offset]);

  React.useEffect(() => {
    if (hash === targetHash) {
      scrollToElement({ elementRef, offset });
    }
  }, [hash, targetHash, elementRef, offset]);
}
